import React from 'react';
import { useMyContext } from '../../../context/MyContext';
import Sidebar from '../../../component/b2c/sidebar/sidebar';
import NavBar from '../../../component/b2c/navBar/navBar';
import {
  FaEnvelope,
  FaWhatsapp,
  FaHeadset,
  FaClock,
  FaArrowRight,
  FaComments,
  FaPhoneAlt,
  FaMailBulk,
  FaRegClock,
  FaReplyAll,
  FaRocket
} from 'react-icons/fa';
import '../../../component/css/custom-scrollbar.css'

const Support = () => {
  const { isDarkMode, isToggleSidebar, setIsToggleSidebar } = useMyContext();

  const supportChannels = [
    {
      icon: <FaEnvelope className="w-5 h-5" />,
      iconColor: 'text-rose-400',
      title: 'Email Support',
      description: 'Detailed responses within 24 hours for all your queries',
      contact: 'support@pickupxpress.com',
      link: 'mailto:support@pickupxpress.com',
      badge: '24 hrs',
      badgeColor: 'bg-rose-500/10 text-rose-300 border-rose-500/30',
      iconBg: 'bg-gradient-to-br from-rose-500/20 to-red-500/10 border border-rose-500/30 shadow-[0_0_15px_rgba(244,63,94,0.2)]',
      btnGradient: 'from-rose-600 to-red-600'
    },
    {
      icon: <FaWhatsapp className="w-5 h-5" />,
      iconColor: 'text-emerald-400',
      title: 'WhatsApp Support',
      description: 'Instant messaging support for quick resolutions and real-time help',
      contact: '+91 XXXX XX 0087',
      link: 'https://wa.me/message/LCC4KAGD5JFUC1',
      badge: 'Instant',
      badgeColor: 'bg-emerald-500/10 text-emerald-300 border-emerald-500/30',
      iconBg: 'bg-gradient-to-br from-emerald-500/20 to-green-500/10 border border-emerald-500/30 shadow-[0_0_15px_rgba(16,185,129,0.2)]',
      btnGradient: 'from-emerald-600 to-green-600'
    }
  ];

  const quickLinks = [
    { icon: <FaComments className="w-3.5 h-3.5" />, label: 'Live Chat', desc: 'Chat with our team', accent: 'from-indigo-500/20 to-purple-500/10', iconColor: 'text-indigo-400', border: 'border-indigo-500/30', glow: 'hover:shadow-[0_0_20px_rgba(99,102,241,0.3)]' },
    { icon: <FaPhoneAlt className="w-3.5 h-3.5" />, label: 'Call Back', desc: 'Request a call', accent: 'from-sky-500/20 to-blue-500/10', iconColor: 'text-sky-400', border: 'border-sky-500/30', glow: 'hover:shadow-[0_0_20px_rgba(14,165,233,0.3)]' },
    { icon: <FaReplyAll className="w-3.5 h-3.5" />, label: 'FAQ', desc: 'Common questions', accent: 'from-amber-500/20 to-orange-500/10', iconColor: 'text-amber-400', border: 'border-amber-500/30', glow: 'hover:shadow-[0_0_20px_rgba(245,158,11,0.3)]' },
    { icon: <FaRocket className="w-3.5 h-3.5" />, label: 'Guide', desc: 'Help center', accent: 'from-purple-500/20 to-pink-500/10', iconColor: 'text-purple-400', border: 'border-purple-500/30', glow: 'hover:shadow-[0_0_20px_rgba(168,85,247,0.3)]' },
  ];

  const glass =
    "backdrop-blur-2xl backdrop-saturate-150 bg-white/50 dark:bg-white/[0.06] " +
    "border border-white/60 dark:border-white/10 " +
    "shadow-[0_8px_32px_rgba(31,41,55,0.08)]";

  return (
    <div className={`h-screen flex flex-col overflow-hidden transition-colors duration-300 ${
      isDarkMode ? 'dark bg-[#0B1120]' : 'bg-gray-50'
    }`}>
      {/* Premium ambient glows */}
      {isDarkMode ? (
        <>
          <div className="pointer-events-none absolute -top-40 -left-32 h-[500px] w-[500px] rounded-full bg-indigo-600/15 blur-[120px]" />
          <div className="pointer-events-none absolute bottom-0 -right-32 h-[400px] w-[400px] rounded-full bg-purple-600/10 blur-[100px]" />
        </>
      ) : (
        <div className="pointer-events-none absolute -top-32 -left-24 h-96 w-96 rounded-full bg-indigo-200/30 blur-3xl" />
      )}

      <NavBar />
      <div className="flex flex-1 overflow-hidden relative z-10">
        {isToggleSidebar && (
          <div
            className="fixed inset-0 z-40 bg-black/40 backdrop-blur-sm md:hidden"
            onClick={() => setIsToggleSidebar(false)}
          />
        )}

        <div
          className={`
                     fixed inset-y-0 left-0 z-50 w-64
                     ${isToggleSidebar ? "translate-x-0" : "-translate-x-full"}
                     md:static md:inset-auto md:z-auto md:translate-x-0
                     ${isToggleSidebar ? "md:w-64" : "md:w-[72px]"}
                     m-3
                     rounded-3xl
                 
                     overflow-hidden
                     transition-all
                     duration-300
                     ease-in-out
                   `}
        >
          <Sidebar />
        </div>

        <div className={`flex-1 p-3 sm:p-4 md:p-5 w-full overflow-y-auto custom-scrollbar transition-colors duration-300 ${
          isDarkMode ? 'bg-[#0B1120]' : 'bg-gray-200'
        }`}>

          <div className="max-w-5xl mx-auto">

            {/* Premium Header */}
            <div className="flex-shrink-0 mb-4 sm:mb-5">
              <div className="flex items-center gap-2 sm:gap-3">
                <div className={`p-2 sm:p-2.5 rounded-xl border transition-all duration-300 ${
                  isDarkMode
                    ? 'bg-gradient-to-br from-sky-500/20 to-blue-500/10 border-sky-500/30 shadow-[0_0_20px_rgba(14,165,233,0.2)]'
                    : 'border-gray-200 bg-white'
                }`}>
                  <FaHeadset size={18} className={isDarkMode ? 'text-sky-400' : 'text-blue-600'} />
                </div>
                <div>
                  <h1 className={`text-sm sm:text-base font-bold tracking-tight transition-colors duration-300 ${
                    isDarkMode ? 'text-white' : 'text-gray-800'
                  }`}>Support Center</h1>
                  <p className={`text-[9px] sm:text-[10px] transition-colors duration-300 ${
                    isDarkMode ? 'text-gray-500' : 'text-gray-400'
                  }`}>We're here to help with any questions or concerns</p>
                </div>
              </div>
            </div>

            {/* Quick Links */}
            <div className="grid grid-cols-2 sm:grid-cols-4 gap-2 mb-4">
              {quickLinks.map((link, idx) => (
                <div 
                  key={idx} 
                  className={`rounded-xl p-2.5 sm:p-3 text-center transition-all duration-300 cursor-pointer border ${
                    isDarkMode
                      ? `bg-gradient-to-br ${link.accent} ${link.border} ${link.glow} hover:scale-[1.02]`
                      : 'bg-white border-gray-200 hover:shadow-sm'
                  }`}
                >
                  <div className={`w-8 h-8 sm:w-9 sm:h-9 mx-auto rounded-lg flex items-center justify-center mb-1.5 ${
                    isDarkMode
                      ? `bg-white/[0.05] ${link.iconColor}`
                      : 'bg-gray-100 text-gray-600'
                  }`}>
                    {link.icon}
                  </div>
                  <p className={`text-[9px] sm:text-[10px] font-bold ${isDarkMode ? 'text-white' : 'text-gray-700'}`}>{link.label}</p>
                  <p className={`text-[7px] sm:text-[8px] ${isDarkMode ? 'text-gray-400' : 'text-gray-400'}`}>{link.desc}</p>
                </div>
              ))}
            </div>

            {/* Support Cards */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
              {supportChannels.map((channel, index) => (
                <div
                  key={index}
                  className={`rounded-2xl border overflow-hidden group transition-all duration-300 ${
                    isDarkMode
                      ? 'bg-gradient-to-br from-[#111827] to-[#0F172A] border-gray-800 hover:border-indigo-500/40 hover:shadow-[0_0_30px_rgba(99,102,241,0.15)]'
                      : 'bg-white border-gray-200 shadow-sm hover:shadow-md'
                  }`}
                >
                  <div className="p-3 sm:p-4">
                    {/* Header */}
                    <div className="flex items-start justify-between mb-2.5 sm:mb-3">
                      <div className="flex items-center gap-2 sm:gap-3">
                        <div className={`w-10 h-10 sm:w-11 sm:h-11 rounded-xl flex items-center justify-center transition-all duration-300 ${
                          isDarkMode 
                            ? channel.iconBg 
                            : 'bg-gray-100'
                        }`}>
                          <span className={isDarkMode ? channel.iconColor : (index === 0 ? 'text-red-500' : 'text-green-500')}>
                            {channel.icon}
                          </span>
                        </div>
                        <div>
                          <h3 className={`text-[10px] sm:text-[11px] font-bold uppercase tracking-wider transition-colors duration-300 ${
                            isDarkMode ? 'text-white' : 'text-gray-800'
                          }`}>
                            {channel.title}
                          </h3>
                          <span className={`text-[7px] sm:text-[8px] font-semibold px-2 py-0.5 rounded-full border inline-block mt-0.5 ${
                            isDarkMode 
                              ? channel.badgeColor 
                              : 'bg-gray-200 text-gray-600 border-transparent'
                          }`}>
                            {channel.badge}
                          </span>
                        </div>
                      </div>
                    </div>

                    {/* Description */}
                    <p className={`text-[9px] sm:text-[10px] leading-relaxed mb-2.5 sm:mb-3 transition-colors duration-300 ${
                      isDarkMode ? 'text-gray-400' : 'text-gray-500'
                    }`}>
                      {channel.description}
                    </p>

                    {/* Contact */}
                    <div className={`rounded-lg px-2.5 sm:px-3 py-1.5 sm:py-2 mb-2.5 sm:mb-3 border transition-colors duration-300 ${
                      isDarkMode
                        ? 'bg-white/[0.03] border-white/10'
                        : 'bg-gray-50 border-gray-100'
                    }`}>
                      <span className={`text-[9px] sm:text-[10px] font-mono font-medium transition-colors duration-300 ${
                        isDarkMode ? 'text-indigo-300' : 'text-gray-700'
                      }`}>
                        {channel.contact}
                      </span>
                    </div>

                    {/* Button */}
                    <a
                      href={channel.link}
                      target="_blank"
                      rel="noopener noreferrer"
                      className={`group/btn inline-flex items-center justify-center w-full py-2 sm:py-2.5 rounded-xl font-bold text-[9px] sm:text-[10px] transition-all duration-300 gap-2 ${
                        isDarkMode
                          ? `bg-gradient-to-r ${channel.btnGradient} text-white hover:shadow-[0_0_25px_rgba(244,63,94,0.4)] hover:scale-[1.02]`
                          : 'bg-red-600 text-white hover:opacity-85'
                      }`}
                    >
                      <span>Contact Support</span>
                      <FaArrowRight className="w-2.5 h-2.5 sm:w-3 sm:h-3 group-hover/btn:translate-x-1 transition-transform duration-300" />
                    </a>
                  </div>
                </div>
              ))}
            </div>

            {/* Hours & Stats */}
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-2 mt-3">
              <div className={`rounded-xl p-2.5 sm:p-3 flex items-center gap-2 sm:gap-3 border transition-all duration-300 ${
                isDarkMode
                  ? 'bg-gradient-to-br from-[#111827] to-[#0F172A] border-gray-800 hover:border-sky-500/40'
                  : 'bg-white border-gray-200'
              }`}>
                <div className={`w-8 h-8 sm:w-9 sm:h-9 rounded-lg flex items-center justify-center shrink-0 transition-all duration-300 ${
                  isDarkMode
                    ? 'bg-sky-500/10 border border-sky-500/30'
                    : 'bg-gray-100'
                }`}>
                  <FaClock className={`w-3 h-3 sm:w-3.5 sm:h-3.5 ${isDarkMode ? 'text-sky-400' : 'text-blue-600'}`} />
                </div>
                <div>
                  <p className={`text-[7px] sm:text-[8px] uppercase tracking-wider transition-colors duration-300 ${
                    isDarkMode ? 'text-gray-500' : 'text-gray-400'
                  }`}>Business Hours</p>
                  <p className={`text-[9px] sm:text-[10px] font-bold transition-colors duration-300 ${
                    isDarkMode ? 'text-white' : 'text-gray-800'
                  }`}>Mon–Sat, 9:00 AM – 6:00 PM</p>
                </div>
              </div>
              
              <div className={`rounded-xl p-2.5 sm:p-3 flex items-center gap-2 sm:gap-3 border transition-all duration-300 ${
                isDarkMode
                  ? 'bg-gradient-to-br from-[#111827] to-[#0F172A] border-gray-800 hover:border-amber-500/40'
                  : 'bg-white border-gray-200'
              }`}>
                <div className={`w-8 h-8 sm:w-9 sm:h-9 rounded-lg flex items-center justify-center shrink-0 transition-all duration-300 ${
                  isDarkMode
                    ? 'bg-amber-500/10 border border-amber-500/30'
                    : 'bg-gray-100'
                }`}>
                  <FaRegClock className={`w-3 h-3 sm:w-3.5 sm:h-3.5 ${isDarkMode ? 'text-amber-400' : 'text-blue-600'}`} />
                </div>
                <div>
                  <p className={`text-[7px] sm:text-[8px] uppercase tracking-wider transition-colors duration-300 ${
                    isDarkMode ? 'text-gray-500' : 'text-gray-400'
                  }`}>Response Time</p>
                  <p className={`text-[9px] sm:text-[10px] font-bold transition-colors duration-300 ${
                    isDarkMode ? 'text-white' : 'text-gray-800'
                  }`}>Within 24 hours</p>
                </div>
              </div>
              
              <div className={`rounded-xl p-2.5 sm:p-3 flex items-center gap-2 sm:gap-3 border transition-all duration-300 sm:col-span-2 md:col-span-1 ${
                isDarkMode
                  ? 'bg-gradient-to-br from-[#111827] to-[#0F172A] border-gray-800 hover:border-emerald-500/40'
                  : 'bg-white border-gray-200'
              }`}>
                <div className={`w-8 h-8 sm:w-9 sm:h-9 rounded-lg flex items-center justify-center shrink-0 transition-all duration-300 ${
                  isDarkMode
                    ? 'bg-emerald-500/10 border border-emerald-500/30'
                    : 'bg-gray-100'
                }`}>
                  <FaWhatsapp className={`w-3 h-3 sm:w-3.5 sm:h-3.5 ${isDarkMode ? 'text-emerald-400' : 'text-green-500'}`} />
                </div>
                <div>
                  <p className={`text-[7px] sm:text-[8px] uppercase tracking-wider transition-colors duration-300 ${
                    isDarkMode ? 'text-gray-500' : 'text-gray-400'
                  }`}>WhatsApp Support</p>
                  <p className={`text-[9px] sm:text-[10px] font-bold transition-colors duration-300 ${
                    isDarkMode ? 'text-white' : 'text-gray-800'
                  }`}>Available 24/7</p>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  );
};

export default Support;